import moment from 'moment'

import { IConfigsType } from '../../types'

const fwWingstopPrepItemCalculator: IConfigsType = {
  'fw_wingstop-prep-item-calculator-store-users-079bdb89': {
    '/:brand/prep_item_calculator': {
      variables: ['date'],
      groupFilter: {
        api: 'fwWingstopPrepCalculatorLocationFilter',
        // DO NOT set the width to make mobile mode look better
      },
      dateFilter: {
        types: ['today', 'custom'],
        defaultType: 'today',
        isDailyCustom: true,
        endDate: moment().add(13, 'days').format('YYYY-MM-DD'),
      },
      title: {
        type: 'title',
        title: 'Prep Item Calculator',
      },
      prepItemCalculator: {
        type: 'ai-blackbox-wrapper',
        contentPartNames: ['fwWingstopPrepItemCalculator'],
        isLocationPage: true,
        hasDateFilter: true,
        hasGroupFilter: true,
        hasSetDate: true,
      },
    },
  },
}

export default fwWingstopPrepItemCalculator
